module.exports = __webpack_public_path__ + "static/img/13.4b3a874.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/services/13.png
// module id = 1lPN
// module chunks = 0